const profileFields = [
    'type', 
    'region', 
    'primary_grape'
];

const flavorFields = [
  'flavor_profile_1_id',
  'flavor_profile_2_id',
  'flavor_profile_3_id',
  'flavor_profile_4_id',
];

const foodPairingFields = [
  'food_category_1_id',
  'food_category_2_id',
  'food_category_3_id',
  'food_category_4_id',
];

const characteristicKeys = {
  wine:    ['sweetness','body','acidity','oak'],
  whiskey: ['sweetness','body','oak','peat'],
  tequila: ['sweetness','agave','smoke','oak'],
  beer:    ['hop','malt','body','sweetness'],
  rtd:     ['sweetness','flavor','carbonation','alcohol'],
  cheese:  ['aromatic','flavor','savouriness','firmness'],
};

const config = Object.fromEntries(
  Object.entries(characteristicKeys).map(([category, keys]) => {
    return [
      category,
      {
        profile:                 profileFields,
        characteristics:         keys,
        characteristics_level:   keys.map(k => `${k}_level`),
        characteristics_percent: keys.map(k => `${k}_percent`),
        flavor:                  flavorFields,
        foodpairing:             foodPairingFields,
      }
    ];
  })
);

export default config;